import { WaypointRunningLateReason } from '@caresend/types';
import { defineComponent } from 'vue';
import __vue_component__ from '../../alerts/Alert.vue.js';
import __vue_component__$1 from '../../buttons/ButtonComponent/ButtonComponent.vue.js';

const delayReasons = {
    [WaypointRunningLateReason.LEFT_TOO_LATE]: 'I left too late',
    [WaypointRunningLateReason.TRAFFIC]: 'Traffic',
    [WaypointRunningLateReason.UNCLEAR_IN_APP_INSTRUCTIONS]: 'Unclear in-app instructions',
    [WaypointRunningLateReason.DELAY_IN_MY_SCHEDULE]: 'Delay in my schedule',
    [WaypointRunningLateReason.OTHER]: 'Other',
};
var script = defineComponent({
    /** Capture why the clinician is too late to the scheduled waypoint time */
    name: 'RunningLateReasonModal',
    components: {
        Alert: __vue_component__,
        ButtonComponent: __vue_component__$1,
    },
    props: {
        isOpened: Boolean,
    },
    setup(_props, { emit }) {
        const captureDelayReason = (reason) => {
            emit('selectDelayReason', reason);
        };
        return {
            captureDelayReason,
            delayReasons,
        };
    },
});

export { script as default };
